import { useModal } from "@/hooks/modals/useModal";
import { Col, Form, Select } from "antd";
import {
  usePurchaseRequestDetail,
  usePurchaseRequestTypeTree,
  type CascaderOption,
} from "../hooks/usePurchaseRequest";
import type { PurchaseRequestForm } from "../type";
import { useTranslation } from "react-i18next";

type SelectFieldProps = {
  name: keyof PurchaseRequestForm;
  label: string;
  options: { label: string; value: string }[];
};

const SelectField = ({ name, label, options }: SelectFieldProps) => (
  <Col span={8}>
    <Form.Item<PurchaseRequestForm>
      name={name}
      label={label}
      rules={[{ required: true, message: "请选择" }]}
    >
      <Select placeholder="请选择" options={options} disabled />
    </Form.Item>
  </Col>
);

const getChildOptions = (
  parentValue: string | undefined,
  parentOptions: CascaderOption[] | undefined,
) => parentOptions?.find((item) => item.value === parentValue)?.children || [];

export const CascaderFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { cascaderOptions } = usePurchaseRequestTypeTree();
  const { props } = useModal("PURCHASE_REQUEST");
  const { dto, recordId } = props;
  const detail = usePurchaseRequestDetail(recordId);

  const materialType1 = detail?.materialType1 || dto?.materialType1;
  const factoryValue = detail?.factoryValue || dto?.factoryValue;
  const materialType2 = detail?.materialType2 || dto?.materialType2;
  const materialType3 = detail?.materialType3 || dto?.materialType3;

  const factoryOptions = getChildOptions(materialType1, cascaderOptions);
  const materialType2Options = getChildOptions(factoryValue, factoryOptions);
  const materialType3Options = getChildOptions(
    materialType2,
    materialType2Options,
  );
  const amountRangeOptions = getChildOptions(
    materialType3,
    materialType3Options,
  );

  return (
    <>
      <SelectField
        name="factoryValue"
        label={t("工厂")}
        options={factoryOptions}
      />
      <SelectField
        name="materialType1"
        label={t("物料类别")}
        options={cascaderOptions}
      />
      <SelectField
        name="materialType2"
        label={t("二级物料类别")}
        options={materialType2Options}
      />
      <SelectField
        name="materialType3"
        label={t("三级采购类别")}
        options={materialType3Options}
      />
      <SelectField
        name="amountRange"
        label={t("申请金额范围")}
        options={amountRangeOptions}
      />
    </>
  );
};
